<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 11:00:25
 * @LastEditTime: 2025-11-07 14:40:13
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-template_textarea">
    <div :class="['textarea_wrap', formatValueLength ? 'is-active' : '']">
      <div class="sub_content_wrap">
        <!-- <template v-if="!$slots.header">
          <div class="header_wrap">
            <div class="header_wrap__left_wrap">1</div>
          </div>
        </template> -->

        <!-- 自定义header -->
        <slot name="header"></slot>

        <template>
          <div class="content_wrap">
            <!-- 图片预览区域 -->
            <div v-if="uploadedImages.length > 0" class="image-preview-wrap">
              <div v-for="(image, index) in uploadedImages" :key="index" class="image-preview-item">
                <!-- 图片文件显示缩略图 -->
                <img v-if="image.isImage" :src="image.url" :alt="image.name" />
                <!-- 非图片文件显示文件图标 -->
                <div v-else class="file-icon-placeholder">
                  <i class="el-icon-document"></i>
                  <span class="file-ext">{{ getFileExtension(image.name) }}</span>
                </div>
                <div class="image-preview-mask">
                  <i class="el-icon-delete" @click="removeImage(index)"></i>
                </div>
                <!-- 上传进度 -->
                <div v-if="image.uploading" class="upload-progress">
                  <el-progress :percentage="image.progress" :show-text="false"></el-progress>
                </div>
                <!-- 上传失败标识 -->
                <div v-if="image.uploadFailed" class="upload-failed">
                  <i class="el-icon-warning"></i>
                </div>
              </div>
            </div>

            <component
              ref="content"
              :is="formatSourceType"
              :valueProp.sync="value"
              v-bind="$attrs"
              v-on="$listeners"
              @on-key-up-enter="onKeyUpEnter"
            ></component>
            <div class="c-operate">
              <!-- 图片上传按钮 -->
              <div class="upload-btn" v-if="$attrs.sourceType === 'global'">
                <el-tooltip content="上传文件" effect="dark" placement="top">
                  <div class="upload-wrap">
                    <input
                      ref="imageInput"
                      type="file"
                      accept=".png,.jpg,.jpeg"
                      multiple
                      style="display: none"
                      @change="handleImageSelect"
                    />
                    <img
                      :src="require('@/components/aiChat/images/svg/uploadIcon.svg')"
                      class="upload-icon"
                      @click="triggerImageUpload"
                    />
                  </div>
                </el-tooltip>
              </div>

              <div class="send">
                <el-tooltip :content="loading ? '停止生成' : '发送'" effect="dark" placement="top">
                  <div
                    :class="['send_wrap', loading ? 'is-stop' : '', isSendDisabled ? 'is-disabled' : '']"
                    @click.stop="
                      () => {
                        isSendDisabled ? null : !isGtRange ? onSendQA({}) : null
                      }
                    "
                  >
                    <img
                      :src="
                        require('@/components/aiChat/images/svg/' +
                          (loading
                            ? 'stopIcon'
                            : isSendDisabled
                            ? 'defaultSendIcon'
                            : !isGtRange
                            ? tokenValueLength
                              ? 'sendIcon'
                              : 'defaultSendIcon'
                            : '') +
                          '.svg')
                      "
                      class="icon"
                    />
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="bg_wrap"></div>
    </div>
    <!-- 自定义footer -->
    <slot name="footer"></slot>
  </div>
</template>

<script>
import TextareaOne from './templates/textareaOne.vue'
import { fetchEventSourceManager } from '@/components/aiChat/utils/fetchEventSourceManager.js'
import { commonMixin } from '@/components/aiChat/common/mixins.js'
import tbox from '@/components/aiChat/utils/tbox.js'
import COS from 'cos-js-sdk-v5'
import { Api } from '@/api'

export default {
  components: { TextareaOne },
  props: {
    isDeepThinkingProp: {
      type: Boolean,
      default: false
    },
    paramsModelDataProp: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  mixins: [commonMixin],
  data() {
    return {
      formatSourceType: 'TextareaOne',
      value: '',
      formatValueLength: '',
      isDisabled: false,
      isGtRange: false,
      loading: false,
      tokenValueLength: 0,
      formModelData: {},
      isSleep: false,
      timer: null,
      tm: null,
      uploadedImages: [], // 存储上传的图片 { name, url, file, uploading, progress, uploadFailed, fullUrl }
      uploadingCount: 0 // 正在上传的图片数量
    }
  },
  computed: {
    isSendDisabled() {
      return this.isDisabled || this.uploadingCount > 0
    }
  },
  methods: {
    async onSendQA({ questionMsg = '', cb = () => {}, images: regenerateImages = [], tools: regenerateTools = [] }) {
      if (fetchEventSourceManager.onGetLoading()) {
        fetchEventSourceManager.onCloseLink({ isManualClose: false })
        // 停止生成时，触发停止对话逻辑并恢复输入框状态
        await this.$emit('on-stop-dialogue', this.paramsModelDataProp.dialogueId)
        this.$store.commit('aiChat/setTextareaIsDisabled', false)
        return
      }
      const myQ = questionMsg ? questionMsg : this.value
      if (!myQ.trim()) {
        this.$message.error('请输入正确内容，不要输入纯空格')
        return
      }

      // 重新生成时跳过上传检查，使用原始图片数据
      const isRegenerate = regenerateImages.length > 0

      // 检查是否有正在上传的图片
      if (!isRegenerate && this.uploadingCount > 0) {
        this.$message.warning('图片正在上传中，请稍候')
        return
      }

      // 检查是否有上传失败的图片
      if (!isRegenerate) {
        const hasFailedUpload = this.uploadedImages.some(img => img.uploadFailed)
        if (hasFailedUpload) {
          this.$message.warning('有图片上传失败，请删除后重试')
          return
        }
      }

      // 发送消息时立即禁用输入框，等待 SSE 响应完成后再恢复
      this.$store.commit('aiChat/setTextareaIsDisabled', true)

      const handle = async () => {
        let dialogueId = null,
          question = questionMsg ? questionMsg : this.value

        if (!question) {
          this.isSleep = false
          this.timer = null
          this.loading = false
          return
        }

        if (this.paramsModelDataProp.dialogueId) {
          dialogueId = this.paramsModelDataProp.dialogueId
        } else {
          try {
            dialogueId = await this.onInsertDialogue({ question })

            this.$emit('on-query-dialogue', dialogueId)
            cb && cb(dialogueId)
          } catch (error) {}
        }
        if (dialogueId) {
          // 获取已上传成功的图片信息列表（重新生成时使用原始图片数据）
          const images = isRegenerate
            ? regenerateImages
            : this.uploadedImages
                .filter(img => img.fullUrl && !img.uploading && !img.uploadFailed)
                .map(img => {
                  const format = img.file.type.split('/')[1] || ''
                  return {
                    name: img.name,
                    format: format,
                    url: img.fullUrl
                  }
                })

          const sourceValue = this.$attrs.sourceType || this.$attrs.source || ''
          const body = {
            chatId: dialogueId,
            id: dialogueId,
            prompt: question,
            question: question,
            isThink: this.isDeepThinkingProp,
            attachments: (sourceValue === 'global' || sourceValue === 'wenshu')
              ? []
              : (isRegenerate
                ? JSON.parse(JSON.stringify(regenerateTools))
                : JSON.parse(JSON.stringify(this.$store.state.aiChat.zzpSelectBtn))),
            images: images // 添加图片信息列表（包含名称、格式、链接）
          }
          if (sourceValue === 'global' || sourceValue === 'wenshu') {
            body.source = sourceValue
          }

          // const body = {
          //   id: '395',
          //   question: '人文关怀：技术不能替代的情感教育',
          //   isThink: false
          // }

          const ty = await fetchEventSourceManager.onSend(body, () => {
            this.value = ''

            // 清空已上传的图片（仅释放图片文件的URL）
            this.uploadedImages.forEach(img => {
              if (img.url) {
                URL.revokeObjectURL(img.url)
              }
            })
            this.uploadedImages = []

            // 清理 zzpSelectBtn，只保留"职位名称"（type: 8）、"标准简历"（type: 2）和"职位画像"（type: 9）318837
            const keepTypes = [2, 8, 9]
            this.$store.state.aiChat.zzpSelectBtn = this.$store.state.aiChat.zzpSelectBtn.filter(
              item => keepTypes.includes(item.type)
            )

            fetchEventSourceManager.emit('on-open', {
              data: {},
              body
            })
          })
        }
      }

      // 休眠操作
      if (this.isSleep) {
        console.log(6767676)
        if (this.timer) return
        console.log(67777)
        await tbox.sleep(3000, e => {
          this.timer = e
        })
      }
      this.isSleep = false
      this.timer = null

      this.loading = !this.loading
      console.log(88888, this.loading)
      if (this.loading == false) {
        // 需要断掉sse
        fetchEventSourceManager.onCloseLink({ isManualClose: false })
        const r = await this.$emit('on-stop-dialogue', this.paramsModelDataProp.dialogueId)
        if (r) {
          // 开启休眠标识
          this.isSleep = true
          // 当没有点击 需要三秒后isSleep设置成false
          this.tm && clearTimeout(this.tm)
          this.tm = setTimeout(() => {
            this.isSleep = false
            this.tm = null
            clearTimeout(this.tm)
          }, 4000)
        }
      } else {
        // 需要开启sse
        handle()
      }
    },

    triggerImageUpload() {
      this.$refs.imageInput.click()
    },

    handleImageSelect(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      // 限制最多上传3张图片
      const maxCount = 3
      if (this.uploadedImages.length >= maxCount) {
        this.$message.warning(`最多只能上传${maxCount}张图片`)
        event.target.value = ''
        return
      }

      // 计算剩余可上传数量
      const remaining = maxCount - this.uploadedImages.length
      const filesToProcess = Array.from(files).slice(0, remaining)

      if (files.length > remaining) {
        this.$message.warning(`最多只能上传${maxCount}张图片，本次已自动截取前${remaining}张`)
      }

      // 支持的文件格式
      const allowedExtensions = ['png', 'jpg', 'jpeg']

      filesToProcess.forEach(file => {
        // 获取文件扩展名
        const fileExtension = file.name.split('.').pop().toLowerCase()

        // 验证文件类型
        if (!allowedExtensions.includes(fileExtension)) {
          this.$message.warning(`${file.name} 文件格式不支持，仅支持：${allowedExtensions.join(', ')}`)
          return
        }

        // 验证文件大小（限制10MB）
        if (file.size > 10 * 1024 * 1024) {
          this.$message.warning(`${file.name} 文件大小超过10MB`)
          return
        }

        // 创建预览URL（对于非图片文件，使用文件对象本身）
        const isImage = ['png', 'jpg', 'jpeg'].includes(fileExtension)
        const url = isImage ? URL.createObjectURL(file) : ''

        const imageItem = {
          name: file.name,
          url: url,
          file: file,
          uploading: true,
          progress: 0,
          uploadFailed: false,
          fullUrl: '',
          isImage: isImage
        }
        this.uploadedImages.push(imageItem)

        // 开始上传
        this.uploadImageToCloud(imageItem)
      })

      // 清空input，允许重复选择同一文件
      event.target.value = ''
    },

    // 上传图片到腾讯云COS
    uploadImageToCloud(imageItem) {
      const that = this
      this.uploadingCount++

      Api.generatorTempSecretId({ filename: encodeURIComponent(imageItem.file.name) })
        .then(res => {
          if (res && res.code === '0') {
            return res
          } else {
            throw new Error('获取上传凭证失败')
          }
        })
        .then(res => {
          if (!res) return

          const cos = new COS({
            getAuthorization: function(options, callback) {
              callback({
                TmpSecretId: res.data.tmpSecretId,
                TmpSecretKey: res.data.tmpSecretKey,
                XCosSecurityToken: res.data.sessionToken,
                StartTime: res.data.startTime,
                ExpiredTime: res.data.expiredTime
              })
            }
          })

          cos.sliceUploadFile(
            {
              Bucket: res.data.bucket,
              Region: res.data.region,
              Key: res.data.path,
              Body: imageItem.file,
              uploadId: res.data.uploadId,
              onProgress: function(progressData) {
                // 更新上传进度
                imageItem.progress = Math.floor(progressData.percent * 100)
              }
            },
            function(err, data) {

              if (err) {
                that.uploadingCount--
                that.$message.warning(`${imageItem.name} 上传失败`)
                imageItem.uploading = false
                imageItem.uploadFailed = true
              } else {
                // 获取下载URL
                Api.getDownloadUrl({ filename: data.Key })
                  .then(url => {
                    that.uploadingCount--
                    if (url.code === '0') {
                      imageItem.fullUrl = url.data.fullUrl
                      imageItem.uploading = false
                      imageItem.uploadFailed = false
                    } else {
                      throw new Error('获取下载链接失败')
                    }
                  })
                  .catch(() => {
                    that.uploadingCount--
                    that.$message.warning(`${imageItem.name} 获取下载链接失败`)
                    imageItem.uploading = false
                    imageItem.uploadFailed = true
                  })
              }
            }
          )
        })
        .catch(e => {
          that.uploadingCount--
          that.$message.warning(`${imageItem.name} 上传失败`)
          imageItem.uploading = false
          imageItem.uploadFailed = true
        })
    },

    removeImage(index) {
      // 释放URL对象（仅对图片文件）
      if (this.uploadedImages[index].url) {
        URL.revokeObjectURL(this.uploadedImages[index].url)
      }
      this.uploadedImages.splice(index, 1)
    },

    getFileExtension(fileName) {
      return fileName.split('.').pop().toUpperCase()
    },

    // 粘贴截图处理
    handlePaste(event) {
      if (this.isDisabled) return

      const items = event.clipboardData && event.clipboardData.items
      if (!items) return

      // 遍历剪贴板内容，找出图片
      const imageFiles = []
      for (let i = 0; i < items.length; i++) {
        if (items[i].type && items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile()
          if (file) imageFiles.push(file)
        }
      }

      if (imageFiles.length === 0) return

      // 非全局模式不支持截图上传
      if (this.$attrs.sourceType !== 'global') {
        event.preventDefault()
        this.$message.warning('面试的ai聊天功能暂时无法上传截图')
        return
      }

      // 有图片时阻止默认粘贴行为（避免把图片数据粘贴到文本框）
      event.preventDefault()

      // 限制最多上传3张图片
      const maxCount = 3
      if (this.uploadedImages.length >= maxCount) {
        this.$message.warning(`最多只能上传${maxCount}张图片`)
        return
      }

      const remaining = maxCount - this.uploadedImages.length
      const filesToProcess = imageFiles.slice(0, remaining)

      if (imageFiles.length > remaining) {
        this.$message.warning(`最多只能上传${maxCount}张图片，本次已自动截取前${remaining}张`)
      }

      filesToProcess.forEach(file => {
        const fileExtension = file.type.split('/')[1] || 'png'
        // 截图通常没有文件名，自动生成一个
        const fileName = file.name || `screenshot_${Date.now()}.${fileExtension}`

        // 验证文件大小（限制10MB）
        if (file.size > 10 * 1024 * 1024) {
          this.$message.warning(`${fileName} 文件大小超过10MB`)
          return
        }

        const url = URL.createObjectURL(file)
        const imageItem = {
          name: fileName,
          url: url,
          file: file,
          uploading: true,
          progress: 0,
          uploadFailed: false,
          fullUrl: '',
          isImage: true
        }
        this.uploadedImages.push(imageItem)

        // 复用现有上传流程
        this.uploadImageToCloud(imageItem)
      })
    },

    onKeyUpEnter(params) {
      console.log(params, 'onKeyUpEnter')
      if (params) {
        this.$nextTick(() => {
          this.onSendQA({ questionMsg: params })
        })
      }
    },

    onCloseLink() {
      console.log('onCloseLink')
      this.loading = false
      this.tokenValueLength = 0
    },

    onChangeField({ key, value }) {
      console.log(key, value, 'onChangeField')
      this[key] = value
    }
  },
  mounted() {
    fetchEventSourceManager.onSetVm(this)
    fetchEventSourceManager.on('on-close-link', this.onCloseLink)
    try {
      this.$bus.on('on-send-suggest-question', this.onSendQA)
      this.$bus.on('on-change-field-by-custom-textarea', this.onChangeField)
    } catch (error) {
      this.$bus.$on('on-send-suggest-question', this.onSendQA)
      this.$bus.$on('on-change-field-by-custom-textarea', this.onChangeField)
    }
    // 监听全局粘贴事件，支持截图粘贴
    document.addEventListener('paste', this.handlePaste)
  },
  beforeDestroy() {
    try {
      this.$bus.off('on-send-suggest-question', this.onSendQA)
      this.$bus.off('on-change-field-by-custom-textarea', this.onChangeField)
    } catch (error) {
      this.$bus.$off('on-send-suggest-question', this.onSendQA)
      this.$bus.$off('on-change-field-by-custom-textarea', this.onChangeField)
    }

    fetchEventSourceManager.off('on-close-link', this.onCloseLink)
    // 移除粘贴事件监听
    document.removeEventListener('paste', this.handlePaste)
  },
  watch: {
    value: {
      handler: function (n) {
        if (n) {
          this.tokenValueLength = 1
        } else {
          this.tokenValueLength = 0
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.c-template_textarea {
  outline: none;
  .textarea_wrap {
    background: #ffffff;
    max-width: 900px;

    border-radius: 8px;
    box-shadow: 0px 6px 9px 0px rgba(0, 0, 0, 0.02);
    // min-width: 800px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    .sub_content_wrap {
      width: 100%;
      height: 100%;
      background-color: #fff;
      position: relative;
      border-radius: 8px;
      z-index: 1;
    }

    .content_wrap {
      padding: 12px;
    }

    .bg_wrap {
      position: absolute;
      left: -1px;
      right: -1px;
      bottom: -1px;
      top: -1px;
      z-index: 0;

      border-radius: 8px;
      border: 1px solid #fff;
      background: linear-gradient(180deg, #fafcff 0%, #ffffff 100%);
    }
  }
}

.c-operate {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 6px;

  .upload-btn {
    margin-right: 12px;

    .upload-wrap {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .upload-icon {
        width: 30px;
        height: 30px;
        transition: opacity 0.3s;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .send {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .send_wrap {
      &.is-stop {
        .icon {
          height: 20px;
          width: 20px;
          border: 2px solid #4e5969;
          border-radius: 50%;
        }
      }
      &.is-disabled {
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .icon {
      width: 24px;
      height: 24px;
      outline: none;
      border-radius: 50%;
    }
  }
}

.image-preview-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;

  .image-preview-item {
    position: relative;
    width: 80px;
    height: 80px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #e5e6eb;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .file-icon-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f7f8fa;

      .el-icon-document {
        font-size: 32px;
        color: #86909c;
        margin-bottom: 4px;
      }

      .file-ext {
        font-size: 12px;
        color: #4e5969;
        font-weight: 500;
      }
    }

    .image-preview-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s;

      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;

        &:hover {
          color: #f53f3f;
        }
      }
    }

    &:hover .image-preview-mask {
      opacity: 1;
    }

    .upload-progress {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 4px;
      background: rgba(0, 0, 0, 0.6);

      ::v-deep .el-progress-bar__outer {
        background-color: rgba(255, 255, 255, 0.3);
      }

      ::v-deep .el-progress-bar__inner {
        background-color: #7657fb;
      }
    }

    .upload-failed {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(245, 63, 63, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #fff;
        font-size: 24px;
      }
    }
  }
}
</style>
